import { IMAGE_CONTROL, IMAGE_DRAG} from '../constants';

export const imageControl = options => {
    return {
        type: IMAGE_CONTROL,
        payload: options
    };
};

export const imageDrag = options => {
    return {
        type: IMAGE_DRAG,
        payload: options
    };
};



/** WEBPACK FOOTER **
 ** ../src/widgets/components/interactive/topScorersMulti/actions/index.js
 **/